"use client";

import { useEffect } from "react";
import { reportClientError } from "@/components/error-reporter";

// Lỗi ở layout gốc (spec admin A2) — thay cả trang nên phải tự có <html>, <body>.
export default function GlobalError({ error, retry }: { error: Error & { digest?: string }; retry: () => void }) {
  useEffect(() => {
    if (!error.digest) reportClientError({ kind: "boundary", message: error.message, stack: error.stack });
  }, [error]);

  return (
    <html lang="vi">
      <body style={{ fontFamily: "system-ui, sans-serif", display: "flex", flexDirection: "column", alignItems: "center", gap: 12, padding: "64px 16px", textAlign: "center" }}>
        <h2 style={{ fontSize: 18, margin: 0 }}>KyFlow gặp lỗi</h2>
        <p style={{ fontSize: 14, color: "#555", margin: 0 }}>
          Lỗi đã được ghi lại. Dữ liệu của bạn không bị ảnh hưởng.
          {error.digest && <span style={{ display: "block", fontSize: 12, paddingTop: 4 }}>Mã lỗi: {error.digest}</span>}
        </p>
        <button onClick={() => retry()} style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #ccc", background: "#111", color: "#fff", cursor: "pointer" }}>
          Thử lại
        </button>
      </body>
    </html>
  );
}
